// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__28Je-","right":"Footer_right__2BRrr","buttons":"Footer_buttons__2Rm24"};